import cloneDeep from 'lodash/cloneDeep'

export default {
    state: {
        customers: [],
    },
    mutations: {
        setCustomers(state, customers) {
            state.customers = customers
        },
        addCustomer(state, customer) {
            state.customers.push(customer)
        },
        updateCustomer(state, customer) {
            const index = state.customers.findIndex(item => item.id === customer.id)

            Vue.set(state.customers, index, customer)
        },
        removeCustomer(state, customerId) {
            state.customers = state.customers.filter(item => item.id !== customerId)
        },
        addLocation(state, location) {
            const customer = state.customers.findIndex(item => item.id === location.customer_id)

            state.customers[customer].locations.push(location)
        },
        updateLocation(state, location) {
            const customer = state.customers.findIndex(item => item.id === location.customer_id)
            const index = state.customers[customer].findIndex(item => item.id === location.id)

            Vue.set(state.customers[customer].locations, index, location)
        },
        addContact(state, contact) {
            const customer = state.customers.findIndex(item => item.id === contact.customer_id)

            state.customers[customer].contacts.push(contact)
        },
        updateContact(state, contact) {
            const customer = state.customers.findIndex(item => item.id === contact.customer_id)
            const index = state.customers[customer].findIndex(item => item.id === contact.id)

            Vue.set(state.customers[customer].contacts, index, contact)
        },
    },
    getters: {
        listCustomers: state => state.customers,
        findCustomer: state => id => state.customers.find(item => item.id === id)
    },
    actions: {
        loadCustomers(context) {
            window.axios.get('/api/customers')
                .then(({ data }) => {
                    context.commit('setCustomers', data)
                })
                .catch(error => console.error(error))
        },
        addCustomer(context, payload) {
            context.commit('addCustomer', payload)
        },
        updateCustomer(context, payload) {
            context.commit('updateCustomer', payload)
        },
        removeCustomer(context, customerId) {
            context.commit('removeCustomer', customerId)
        },
        addLocation(context, payload) {
            context.commit('addLocation', payload)
        },
        updateLocation(context, payload) {
            context.commit('updateLocation', payload)
        },
        addContact(context, payload) {
            context.commit('addContact', payload)
        },
        updateContact(context, payload) {
            context.commit('updateContact', payload)
        },
    }
}
